import React from "react";
import { useNavigate } from "react-router-dom";

const CustomErroPage = () => {
    const navigate = useNavigate();
    const navigatelogin = () => {
        localStorage.clear();
        sessionStorage.clear();
        navigate("/Login", { replace: true });
    };

    return (
        <>         

            <span style={{ fontWeight: "bold", display: "flex", justifyContent: "center", fontSize: "xx-large" }} > Something went wrong. Please try again after sometime.</span>
            <img src="https://www.pngitem.com/pimgs/m/253-2530395_oops-png-transparent-png.png" alt="Error"
                style={{ height: "80vh", display: "flex", left: "0px", top: "0px", position: "relative", margin: "auto" }}
            />

            <button className="Buttons" style={{ display: "block", padding: "10px",margin:"auto",marginTop:"1rem" }} onClick={navigatelogin}>Click here to re-login</button>
        </>
    )
};
export default CustomErroPage;